
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { iDevice } from '@/interface/result';
import { putMachines } from '@/api/deviceManaging';
import { toast } from '@/utils/common';
import moment from 'moment';
@Component({
  filters: {
    yyyy_mm_dd(val: number) {
      return moment(val * 1000).format('YYYY/MM/DD HH:mm:ss');
    },
  },
})
export default class PopDetail extends Vue {
  @Prop() visible!: boolean;
  @Prop() rowObj!: iDevice;
  @Emit() ok() {}

  private dpObj = {};
  private isEdit = false;
  private detailObj: iDevice = {
    area_id: 0,
    area_name: '',
    config_id: 0,
    id: 0,
    ip: 0,
    mac: ' ',
    mask: ' ',
    port: '',
    region_id: 0,
    region_name: ' ',
    seq: ' ',
    status: 0,
    status_desc: ' ',
    token: '',
  };

  editPop() {
    this.isEdit = true;
  }
  @Emit() cancel() {
    this.detailObj = JSON.parse(JSON.stringify(this.dpObj));
  }
  async confirmEdit() {
    try {
      this.detailObj.config_id = Number(this.detailObj.config_id);
      const res = await putMachines(this.detailObj);
      if (res && res.code === 0) {
        toast('修改成功');
        this.$emit('ok');
      }
    } catch (error) {
      console.log(error);
    }
  }

  mounted() {
    this.dpObj = JSON.parse(JSON.stringify(this.rowObj));
    this.detailObj = JSON.parse(JSON.stringify(this.rowObj));
  }
}
